import type { SVGProps } from "react";
export default function SvgQuestionnairesAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={109.415} height={116.684} x={1.29297} y={-0.683594}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_661_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_661)">
				<path
					fill="url(#paint0_linear_1110_661)"
					fillOpacity={0.6}
					d="M92.672 48.651c-.143-3.377-1.617-6.898-4.49-9.124L62.209 19.406c.04.033.066.085.096.13-.03-.045-.055-.1-.096-.13-3.77-2.817-8.83-2.751-12.39-.013-2.21 1.713-25.895 20.041-25.993 20.14-2.963 2.411-4.366 5.854-4.497 9.123-.007-.168-.035-.334-.035-.503V88.52c0 5.236 4.245 9.481 9.481 9.481h54.452c5.236 0 9.481-4.245 9.481-9.48V48.152c0 .169-.03.332-.035.498"
				/>
				<path
					stroke="url(#paint1_linear_1110_661)"
					d="M50.122 19.79c3.366-2.589 8.151-2.666 11.74-.017l.005.01.02.031.017-.011 25.973 20.12c2.735 2.12 4.158 5.492 4.296 8.75l.034-.001V88.52c0 4.96-4.021 8.98-8.981 8.98H28.774a8.98 8.98 0 0 1-8.981-8.98V48.676h.035c.126-3.145 1.475-6.447 4.313-8.757l.02-.016-.002.001.052-.042.205-.16.77-.6 2.738-2.123 8.412-6.516c6.206-4.806 12.676-9.814 13.785-10.675z"
				/>
			</g>
			<g filter="url(#filter1_i_1110_661)">
				<g opacity={0.45}>
					<path
						fill="white"
						fillOpacity={0.01}
						d="M80.485 14H31.52a4.79 4.79 0 0 0-4.791 4.79v53.811a4.79 4.79 0 0 0 4.791 4.791h48.966a4.79 4.79 0 0 0 4.791-4.79V18.79A4.79 4.79 0 0 0 80.486 14"
					/>
					<path
						stroke="url(#paint2_linear_1110_661)"
						strokeOpacity={0.5}
						d="M31.519 14.5h48.967a4.29 4.29 0 0 1 4.29 4.291v53.81a4.29 4.29 0 0 1-4.29 4.29H31.519a4.29 4.29 0 0 1-4.291-4.29v-53.81a4.29 4.29 0 0 1 4.291-4.291Z"
					/>
				</g>
			</g>
			<foreignObject width={109.415} height={85.8467} x={1.29297} y={30.1494}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_661_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_i_1110_661)">
				<path
					fill="url(#paint3_linear_1110_661)"
					fillOpacity={0.6}
					d="M83.226 97.996H28.774c-5.236 0-9.481-4.245-9.481-9.48V48.148c0 4.854 2.794 9.275 7.18 11.358l25.042 11.89a10.46 10.46 0 0 0 8.97 0l25.042-11.89a12.57 12.57 0 0 0 7.18-11.358v40.366c0 5.236-4.245 9.481-9.481 9.481"
				/>
				<path
					stroke="url(#paint4_linear_1110_661)"
					d="M19.793 53.161a13.07 13.07 0 0 0 6.466 6.797l25.04 11.89a10.96 10.96 0 0 0 9.401 0l25.041-11.89a13.07 13.07 0 0 0 6.466-6.795v35.353c0 4.96-4.021 8.98-8.981 8.98H28.774a8.98 8.98 0 0 1-8.981-8.98z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M74.413 33.321H37.586a2.034 2.034 0 1 1 0-4.069h36.827a2.034 2.034 0 1 1 0 4.069"
			/>
			<path
				fill="#FAFF00"
				d="M74.413 45.612H37.586a2.034 2.034 0 1 1 0-4.069h36.827a2.034 2.034 0 1 1 0 4.069"
			/>
			<path
				fill="#FAFF00"
				d="M74.413 57.902H37.586a2.034 2.034 0 1 1 0-4.069h36.827a2.034 2.034 0 1 1 0 4.069"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_661"
					x1={56.1873}
					x2={56.1873}
					y1={17.3164}
					y2={98.0003}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_661"
					x1={56.0001}
					x2={24.3665}
					y1={18.2}
					y2={82.1656}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_661"
					x1={56.0022}
					x2={56.0022}
					y1={14}
					y2={77.392}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1110_661"
					x1={56.1873}
					x2={56.1873}
					y1={48.1494}
					y2={97.9964}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_1110_661"
					x1={56.0001}
					x2={42.2561}
					y1={48.6953}
					y2={93.6795}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<filter
					id="filter0_i_1110_661"
					width={109.415}
					height={116.684}
					x={1.29297}
					y={-0.683594}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_661" />
				</filter>
				<filter
					id="filter1_i_1110_661"
					width={94.5483}
					height={99.3916}
					x={8.72803}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_661" />
				</filter>
				<filter
					id="filter2_i_1110_661"
					width={109.415}
					height={85.8467}
					x={1.29297}
					y={30.1494}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_661" />
				</filter>
				<clipPath id="bgblur_0_1110_661_clip_path" transform="translate(-1.293 .684)">
					<path d="M92.672 48.651c-.143-3.377-1.617-6.898-4.49-9.124L62.209 19.406c.04.033.066.085.096.13-.03-.045-.055-.1-.096-.13-3.77-2.817-8.83-2.751-12.39-.013-2.21 1.713-25.895 20.041-25.993 20.14-2.963 2.411-4.366 5.854-4.497 9.123-.007-.168-.035-.334-.035-.503V88.52c0 5.236 4.245 9.481 9.481 9.481h54.452c5.236 0 9.481-4.245 9.481-9.48V48.152c0 .169-.03.332-.035.498" />
				</clipPath>
				<clipPath id="bgblur_1_1110_661_clip_path" transform="translate(-1.293 -30.15)">
					<path d="M83.226 97.996H28.774c-5.236 0-9.481-4.245-9.481-9.48V48.148c0 4.854 2.794 9.275 7.18 11.358l25.042 11.89a10.46 10.46 0 0 0 8.97 0l25.042-11.89a12.57 12.57 0 0 0 7.18-11.358v40.366c0 5.236-4.245 9.481-9.481 9.481" />
				</clipPath>
			</defs>
		</svg>
	);
}
